// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBNsYlb5xPXWiuXzbEjRbA6GgW9j00e-lI",
  authDomain: "winter-travel-destination.firebaseapp.com",
  projectId: "winter-travel-destination",
  storageBucket: "winter-travel-destination.appspot.com",
  messagingSenderId: "164444254971",
  appId: "1:164444254971:web:541dfc3d7517354bea765e"
};

  export default firebaseConfig;